import Footer from '@/components/footer'
import Header from '@/components/header'

export const CancellationPolicy = () => {
	return (
		<div className="bg-landing-page bg-cover bg-no-repeat">
			<div className="max-w-[150rem] mx-auto">
				<Header currentPage="cancellation" />
				<div className="mt-5 lg:mt-[90px] flex items-center flex-col gap-3 lg:gap-2">
					<h1 className="text-secondary text-center text-xl lg:text-5xl font-extrabold">
						Widerrufsbelehrung
					</h1>
					<p className="text-secondary text-center text-sm lg:text-xl font-medium">
						Informationen zu Ihrem Widerrufsrecht
					</p>
				</div>
				<div className="mt-8 lg:px-[55px] px-5 lg:mt-[86px] flex flex-col gap-8">
					<div className="flex flex-col gap-2">
						<h2 className="text-secondary lg:text-2xl font-extrabold">1 . Widerrufsrecht</h2>
						<ol className="list-decimal leading-[29px] lg:leading-[42px] text-muted-foreground text-xs lg:text-xl font-medium list-outside ml-4 lg:ml-6">
							<li>
								Sie haben das Recht, binnen vierzehn Tagen ohne Angabe von Gründen diesen Vertrag zu
								widerrufen. <br /> Die Widerrufsfrist beträgt 14 Tage nach Erhalt der
								Buchungsbestätigung. <br /> Liegt zwischen Buchungsbestätigung und Mietbeginn
								weniger als 14 Tage, verzichten Sie auf Ihr Widerrufsrecht. In diesem Fall gelten
								die in den AGB getroffenen Bestimmungen.
							</li>
							<li>
								Diese lauten wie folgt: <br />
								Bis sieben Tage vor Mietbeginn erfolgt bei Stornierungen eine Rückerstattung von 50
								% der Mietkosten. Bei weniger als sieben Tagen bis Mietbeginn, verzichtet der Kunde
								im Falle einer Stornierung automatisch auf eine Rückerstattung der Mietkosten. Um
								Ihr Widerrufsrecht auszuüben, müssen Sie uns (Mirzoyan GbR, Kieler Straße 113, 24119
								Kronshagen) mittels einer eindeutigen Erklärung (z. B. eine E-Mail oder per Post)
								über Ihren Entschluss, diesen Vertrag zu widerrufen, informieren. Zur Wahrung der
								Widerrufsfrist reicht es aus, dass Sie die Mitteilung über die Ausübung des
								Widerrufsrechts vor Ablauf der Widerrufsfrist absenden.
							</li>
						</ol>
					</div>
					<div className="flex flex-col gap-2">
						<h2 className="text-secondary lg:text-2xl font-extrabold">2 . Folgen des Widerrufs</h2>
						<ol className="list-decimal leading-[29px] lg:leading-[42px] text-muted-foreground text-xs lg:text-xl font-medium list-outside ml-4 lg:ml-6">
							<li>
								Wenn Sie diesen Vertrag widerrufen, haben wir Ihnen alle Zahlungen, die wir von
								Ihnen erhalten haben, einschließlich der Lieferkosten (mit Ausnahme der zusätzlichen
								Kosten, die sich daraus ergeben, dass Sie eine andere Art der Lieferung als die von
								uns angebotene, günstigste Standardlieferung gewählt haben), unverzüglich und
								spätestens binnen vierzehn Tagen ab dem Tag zurückzuzahlen, an dem die Mitteilung
								über Ihren Widerruf dieses Vertrags bei uns eingegangen ist. Für diese Rückzahlung
								verwenden wir dasselbe Zahlungsmittel, das Sie bei der ursprünglichen Transaktion
								eingesetzt haben, es sei denn, mit Ihnen wurde ausdrücklich etwas anderes
								vereinbart; in keinem Fall werden Ihnen wegen dieser Rückzahlung Entgelte berechnet.
							</li>
						</ol>
					</div>
				</div>
				<div className="mt-16 lg:mt-[141px] bg-[#E6E6E6] w-full h-px" />
				<Footer />
			</div>
		</div>
	)
}
